module.exports = __webpack_public_path__ + "img/20200507_134451.a1af31e8.jpg";